import { getMessage } from '../../components';

export default messages => {
    return {
        foreignTax: {
            identifier: 'foreignTax',
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required')
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.payoutInfo.foreignTax'),
                default: getMessage(messages, 'epic.common.yes')
            },
            optionLabel: {
                yes: getMessage(messages, 'epic.esport.label.payoutInfo.foreignTax.yes'),
                no: getMessage(messages, 'epic.esport.label.payoutInfo.foreignTax.no')
            }
        },
        businessName: {
            identifier: 'businessName',
            display: {
                text: getMessage(messages, 'epic.esport.label.payoutInfo.businessName')
            }
        },
        nameOnTaxId: {
            identifier: 'legalName',
            required: true,
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required')
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.payoutInfo.nameOnTaxId')
            }
        },
        businessType: {
            identifier: 'businessType',
            required: true,
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required')
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.payoutInfo.businessType')
            }
        },
        taxType: {
            identifier: 'taxType',
            required: true,
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required')
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.payoutInfo.taxType')
            }
        },
        phoneNumber: {
            identifier: 'phoneNumber',
            validations: {
                maxLength: 17,
                isValidPhoneNumber: true
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                isValidPhoneNumber: getMessage(messages, 'errors.epic.validation.valied', [getMessage(messages, 'epic.esport.label.payoutInfo.phoneNumber')]),
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.payoutInfo.phoneNumber'), '17'])
            },
            display: {
                text: 'Phone Number'
            }
        },
        address: {
            identifier: 'address.street',
            required: true,
            validations: {
                maxLength: 128
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.payoutInfo.address'), '128'])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.payoutInfo.address')
            }
        },
        city: {
            identifier: 'address.city',
            required: true,
            validations: {
                maxLength: 32
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.payoutInfo.address'), '32'])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.payoutInfo.city')
            }
        },
        zip: {
            identifier: 'address.zip',
            required: true,
            validations: {
                maxLength: 32,
                isValidZip: true
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.payoutInfo.zip'), '32']),
                isValidZip: getMessage(messages, 'errors.epic.validation.valied', [getMessage(messages, 'epic.esport.label.payoutInfo.zip')])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.payoutInfo.zip')
            }
        },
        country: {
            identifier: 'address.country',
            required: true,
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required')
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.payoutInfo.country')
            }
        },
        state: {
            identifier: 'address.state',
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required')
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.payoutInfo.state')
            }
        },
        region: {
            identifier: 'address.state',
            validations: {
                maxLength: 32
            },
            validationMessages: {
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.payoutInfo.region'), '32'])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.payoutInfo.region'),
                text_state: getMessage(messages, 'epic.esport.label.payoutInfo.state')
            }
        },
        postalCode: {
            identifier: 'address.zip',
            validations: {
                maxLength: 32
            },
            validationMessages: {
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.payoutInfo.postalCode'), '32'])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.payoutInfo.postalCode')
            }
        },
        /* TAX ID */
        SSN: {
            identifier: 'taxId',
            required: true,
            validations: {
                isValidSSN: true
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                isValidSSN: getMessage(messages, 'errors.epic.validation.valied', [getMessage(messages, 'epic.esport.label.payoutInfo.SSN')])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.payoutInfo.SSN'),
                placeholder: getMessage(messages, 'epic.esport.placeholder.payoutInfo.SSN')
            }
        },
        EIN: {
            identifier: 'taxId',
            required: true,
            validations: {
                maxLength: 128,
                minLength: 9
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.payoutInfo.EIN'), '128']),
                minLength: getMessage(messages, 'errors.epic.validation.minLength', [getMessage(messages, 'epic.esport.label.payoutInfo.EIN'), '9'])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.payoutInfo.EIN'),
                placeholder: getMessage(messages, 'epic.esport.placeholder.payoutInfo.EIN')
            }
        },
        VAT: {
            required: true,
            identifier: 'taxId',
            validations: {
                maxLength: 128,
                isValidTAXID: true
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.payoutInfo.VAT'), '128']),
                isValidTAXID: getMessage(messages, 'errors.com.epicgames.validation.invalid', [getMessage(messages, 'epic.esport.label.payoutInfo.VAT')])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.payoutInfo.VAT'),
                placeholder: getMessage(messages, 'epic.esport.placeholder.payoutInfo.VAT')
            }
        },
        TAXID: {
            required: true,
            identifier: 'taxId',
            validations: {
                maxLength: 128,
                isValidTAXID: true
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.payoutInfo.TAXID'), '128']),
                isValidTAXID: getMessage(messages, 'errors.com.epicgames.validation.invalid', [getMessage(messages, 'epic.esport.label.payoutInfo.TAXID')])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.payoutInfo.TAXID'),
                placeholder: getMessage(messages, 'epic.esport.placeholder.payoutInfo.TAXID')
            }
        }
    };
};
